import { shopManagerApi } from 'configs';
import api from 'configs/api';

import {
  getHelpSubCategoriesStart,
  getHelpSubCategoriesSuccess,
  getHelpSubCategoriesFailed,
  getHelpCategoriesStart,
  getHelpCategoriesSuccess,
  getHelpCategoriesFailed,
  getHelpTopicsStart,
  getHelpTopicsSuccess,
  getHelpTopicsFailed,
  getAllHelpTopicsStart,
  getAllHelpTopicsSuccess,
  getAllHelpTopicsFailed,
  addHelpCategoryStart,
  addHelpCategorySuccess,
  addHelpCategoryFailed,
  addHelpSubCategoryStart,
  addHelpSubCategorySuccess,
  addHelpSubCategoryFailed,
  addHelpTopicStart,
  addHelpTopicSuccess,
  addHelpTopicFailed,
  editHelpCategoryStart,
  editHelpCategorySuccess,
  editHelpCategoryFailed,
  deleteHelpCategoryStart,
  deleteHelpCategorySuccess,
  deleteHelpCategoryFailed,
  deleteHelpSubCategoryStart,
  deleteHelpSubCategorySuccess,
  deleteHelpSubCategoryFailed,
  editHelpSubCategoryStart,
  editHelpSubCategorySuccess,
  editHelpSubCategoryFailed,
  deleteHelpTopicStart,
  deleteHelpTopicSuccess,
  deleteHelpTopicFailed,
  editHelpTopicStart,
  editHelpTopicSuccess,
  editHelpTopicFailed
} from 'redux/actions/help';

import { serialize } from '../helpers/api';


export const getHelpCategoriesApi = async ({dispatch}) => {
  try {
    dispatch(getHelpCategoriesStart());
    const {data} = await api.get(`${shopManagerApi}/help/categories`);
    dispatch(getHelpCategoriesSuccess(data));
  } catch (e) {
    dispatch(getHelpCategoriesFailed(e));
  }
};

export const getHelpSubCategoriesApi = async ({dispatch, categoryUrl}) => {
  try {
    dispatch(getHelpSubCategoriesStart());
    const filterObj: IFilterObj = {};

    if (categoryUrl) {
      filterObj.categoryUrl = categoryUrl;
    }

    const {data} = await api.get(`${shopManagerApi}/help/sub-categories${serialize(filterObj)}`);
    dispatch(getHelpSubCategoriesSuccess(data));
  } catch (e) {
    dispatch(getHelpSubCategoriesFailed(e));
  }
};

export const getHelpTopicsApi = async ({dispatch, subCategoryUrl, categoryUrl}) => {
  try {
    dispatch(getHelpTopicsStart());
    const filterObj: IFilterObj = {subCategoryUrl};

    if (categoryUrl) {
      filterObj.categoryUrl = categoryUrl;
    }

    const {data} = await api.get(`${shopManagerApi}/help/topics${serialize(filterObj)}`);
    dispatch(getHelpTopicsSuccess(data));
  } catch (e) {
    dispatch(getHelpTopicsFailed(e));
  }
};

export const getAllHelpTopicsApi = async ({dispatch}) => {
  try {
    dispatch(getAllHelpTopicsStart());
    const {data} = await api.get(`${shopManagerApi}/help/topics`);
    dispatch(getAllHelpTopicsSuccess(data));
  } catch (e) {
    dispatch(getAllHelpTopicsFailed(e));
  }
};

export const addHelpCategoryApi = async ({dispatch, category}) => {
  try {
    dispatch(addHelpCategoryStart());
    const {data} = await api.post(`${shopManagerApi}/help/categories`, category);
    dispatch(addHelpCategorySuccess(data));
  } catch (e) {
    dispatch(addHelpCategoryFailed(e));
  }
};

export const addHelpSubCategoryApi = async ({dispatch, subCategory}) => {
  try {
    dispatch(addHelpSubCategoryStart());
    const {data} = await api.post(`${shopManagerApi}/help/sub-categories`, subCategory);
    dispatch(addHelpSubCategorySuccess(data));
  } catch (e) {
    dispatch(addHelpSubCategoryFailed(e));
  }
};

export const addHelpTopicApi = async ({dispatch, helpTopic}) => {
  try {
    dispatch(addHelpTopicStart());
    const {data} = await api.post(`${shopManagerApi}/help/topics`, helpTopic);
    dispatch(addHelpTopicSuccess(data));
  } catch (e) {
    dispatch(addHelpTopicFailed(e));
  }
};

export const editHelpCategoryApi = async ({dispatch, category, categoryId}) => {
  try {
    dispatch(editHelpCategoryStart());
    const {data} = await api.patch(`${shopManagerApi}/help/categories/${categoryId}`, category);
    dispatch(editHelpCategorySuccess(data));
  } catch (e) {
    dispatch(editHelpCategoryFailed(e));
  }
};

export const editHelpSubCategoryApi = async ({dispatch, subCategory}) => {
  try {
    dispatch(editHelpSubCategoryStart());
    const {data} = await api.patch(`${shopManagerApi}/help/sub-categories/${subCategory._id}`, subCategory);
    dispatch(editHelpSubCategorySuccess(data));
  } catch (e) {
    dispatch(editHelpSubCategoryFailed(e));
  }
};

export const editHelpTopicApi = async ({dispatch, topic}) => {
  try {
    dispatch(editHelpTopicStart());
    const {data} = await api.patch(`${shopManagerApi}/help/topics/${topic._id}`, topic);
    dispatch(editHelpTopicSuccess(data));
  } catch (e) {
    dispatch(editHelpTopicFailed(e));
  }
};

export const deleteHelpCategoryApi = async ({dispatch, categoryId}) => {
  try {
    dispatch(deleteHelpCategoryStart());
    await api.delete(`${shopManagerApi}/help/categories/${categoryId}`);
    dispatch(deleteHelpCategorySuccess(categoryId));
  } catch (e) {
    dispatch(deleteHelpCategoryFailed(e));
  }
};

export const deleteHelpSubCategoryApi = async ({dispatch, subCategoryId}) => {
  try {
    dispatch(deleteHelpSubCategoryStart());
    await api.delete(`${shopManagerApi}/help/sub-categories/${subCategoryId}`);
    dispatch(deleteHelpSubCategorySuccess(subCategoryId));
  } catch (e) {
    dispatch(deleteHelpSubCategoryFailed(e));
  }
};

export const deleteHelpTopicApi = async ({dispatch, topicId}) => {
  try {
    dispatch(deleteHelpTopicStart());
    await api.delete(`${shopManagerApi}/help/topics/${topicId}`);
    dispatch(deleteHelpTopicSuccess(topicId));
  } catch (e) {
    dispatch(deleteHelpTopicFailed(e));
  }
};
